import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ComSpecBlockType, PieGraphItem } from 'src/app/model/commodities-graph';
import { NavigationOptions } from 'src/app/model/queryParams';
import { VerticalGraph, VerticalGraphItem } from 'src/app/model/vertical-views';
import { Subject, takeUntil} from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { chartTypeMap, GraphType } from 'src/app/model/generic-graph';

type userSelectionData = {
  pieIndex: number;
  data: any;
}

/**
 * @description
 * This component acts as a container for businesss groups (commodities and sepcialties) activity graphs.
 * It handles the connection between pie graphs, detailed vertical bar graph and finanicial data table, according to the sellected business group.
 */
@Component({
  selector: 'app-com-spec-slide',
  templateUrl: './com-spec-slide.component.html',
  styleUrls: ['./com-spec-slide.component.scss']
})
export class ComSpecSlideComponent {
  @Input() data: any = null;
  @Input() graphData: any = null;
  @Input() navState: any = null;
  @Input() navInfo: NavigationOptions = {};
  @Input() isLoading: boolean = true;
  @Output() currentUserSelectedData = new EventEmitter<userSelectionData>();

  @Input() set userData(data: any) {
    this._userData = data;
    if (data) {
      if (data.pieIndex || data.pieIndex === 0) {
        this.selectedPieIndex = data.pieIndex;
      }
      if (data.data && data.data.colName && this.data) {
        const currentGraphIndex = this.data.graph.graphs[this.selectedPieIndex].data.findIndex(
          (item: any) => item.colName === data.data.colName
        )
        if (currentGraphIndex > -1 && this.selectedColoumnIndex !== currentGraphIndex) {
          this.onSelectGarphValue(currentGraphIndex);
        }
      }
    }
  }
  get userData(): any {
    return this._userData;
  }

  // public selectedBusinessGroup: string = ComSpecBlockType[0];

  public selectedPieIndex: number = 0;
  public selectedColoumnIndex!: number;
  public currentVerticalGraph: VerticalGraph | null = null;
  public currentPieGraph: PieGraphItem[] = [];
  public types: any = ComSpecBlockType;

  private _userData: any;
  public isPercentage: boolean = false;
  public currentPath: any = {};
  private _destroyed$ = new Subject();
  constructor(private cdr: ChangeDetectorRef, private dataService: DataService) { }

  public handleGraphChange() {
    this.selectedPieIndex = this.data.graph.defaultPieGraphIndex ?? 0;
    //select default graph column
    this.data.graph.graphs[this.selectedPieIndex].data.forEach((item: VerticalGraphItem, index: number) => {
      if (item.isDefault) {
        this.selectedColoumnIndex = index;
      }
    });

    if(this.userData) {
      if(this.userData.pieIndex || this.userData.pieIndex === 0) {
        this.selectedPieIndex = this.userData.pieIndex;
      }
      if(this.userData.data) {
        const colIndex =  this.data.graph.graphs[this.selectedPieIndex].data.findIndex(
          (item: any) => item.colName === this.userData.data.colName
        )
        if(colIndex > -1) {
          this.selectedColoumnIndex = colIndex;
        }
      }
    }
  }


  ngOnInit(): void {
    this.dataService.currentPath.pipe(takeUntil(this._destroyed$)).subscribe(params => {
      this.currentPath = params;
    });
  }
  ngOnDestroy(): void {
    this._destroyed$.next(true);
  }
  public selectBusinessGroup(businessGroup: PieGraphItem): void {
    const timeRangeMap = ['M','QTD','YTD']
    const currentSlideMap = ['last year','no comparasion','budget']
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'fireEvent',
      'event_name': 'element_click',
      'division':this?.currentPath?.div || 'ICL',
      'chart_name':this?.graphData?.title || 'Sales',
      'type': 'engagement',
      'section': 'chart',
      'chart_type': chartTypeMap.get(GraphType.Commodities),
      'chart_state':this?.navState?.dropdown || 'Sales',
      'time_range':timeRangeMap[this?.navState?.nav || 0], 
      'comparison_scope': currentSlideMap[this?.navState?.slide !== undefined ? this?.navState?.slide : 1], 
      'sub_business_unit':undefined,
      'purpose':'displaying number',
      'description':'pie slice'
    });

    this.selectedPieIndex = businessGroup.title.toLowerCase() === 'commodities' ? 0 : 1;
    // this.currentVerticalGraph =this.data.graph.graphs[this.selectedPieIndex];
    this.currentUserSelectedData.emit({
      pieIndex: this.selectedPieIndex,
      data: this.userData ? this.userData.data : null
    });
    this.cdr.detectChanges();
  }


  public onSelectGarphValue(columnIndex: number): void {
    this.selectedColoumnIndex = columnIndex;
    // this.currentPieGraph =this.data.graph.pieGraphs[columnIndex].data;
    this.cdr.detectChanges();
  }

  public onUserBarSelect(data: any): void {
    this.currentUserSelectedData.emit({
      pieIndex: this.selectedPieIndex,
      data: data
    });
  }

  ngOnChanges(changes: SimpleChanges) {    
    if(changes['data']) {
      this.handleGraphChange();
    }
    if(this.navState && this?.graphData?.navigation?.nav){
      const currentItem = this.graphData.navigation.nav.find((item: any )=> item.title == this.navState.dropdown)
      this.isPercentage = currentItem?.isPercentage || false
    }else{
      this.isPercentage = false
    }
  }
}
